
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from "react";
import {
  getPathsFromContext,
  getResourceByPath,
  getResourceCollection,
} from "next-drupal";
import Layout from "components/Layout";
import NodeNewsContent from "components/News/NodeNewsContent";
import { DrupalJsonApiParams } from "drupal-jsonapi-params";
import getCrumbs from "lib/getCrumbs";
import { getGlobals } from "lib/getGlobals";
import Header from "components/Header";
import fixPathsSlug from "lib/fixPathsSlug";
import { formatDate } from "lib/formatDate";
import Meta from "components/Meta";
import { CalendarIcon } from "@heroicons/react/outline";
import useTranslation from "next-translate/useTranslation";
import { getPathFromContext } from "lib/i18n";
import getParams from "lib/getParams";
import Pattern3 from "components/Patterns/Pattern3";
import dynamic from "next/dynamic";

const NodeNewsList = dynamic(() => import("components/News/NodeNewsList"));

export default function NewsSlugPage({ globals, crumbs, node, nodes }) {
  const { t } = useTranslation("common");

  if (!node) return null;
  const date = formatDate(node.created);
  const hasNodes = nodes.length > 0;

  return (
    <Layout
      globals={globals}
      header={
        <Header
          crumbs={crumbs}
          title={node.title}
          subtitle={
            <time dateTime={node.created} className="inline-flex items-center">
              <CalendarIcon className="h-5 w-5 mr-2" />
              <span className="text-xs font-important font-medium tracking-wider uppercase">
                {t("utils.published_on", { date })}
              </span>
            </time>
          }
        />
      }
    >
      <Meta
        title={node.title}
        description={
          node.body ? node.body.summary || node.body.summary || null : null
        }
      />

      <section className="relative pb-28 z-20">
        <div className="relative container mx-auto px-4 lg:max-w-screen-lg">
          <NodeNewsContent node={node} />
        </div>
      </section>

      {hasNodes && (
        <div className="relative pt-16 pb-28">
          <div
            className="hidden lg:block absolute inset-y-0 right-0 w-10/12 bg-primary-light"
            aria-hidden="true"
          />

          <div className="absolute top-0 right-0 -translate-y-1/4">
            <Pattern3 className="text-primary" />
          </div>

          <div className="relative container mx-auto px-4">
            <h2 className="text-2xl font-important font-bold mb-16 lg:ml-56">
              {t("news.others.title")}
            </h2>

            <NodeNewsList nodes={nodes} />
          </div>
        </div>
      )}
    </Layout>
  );
}

export async function getStaticPaths(context) {
  const drupalPaths = await getPathsFromContext("node--news", context);

  return {
    paths: fixPathsSlug(drupalPaths),
    fallback: "blocking",
  };
}

 async function _getStaticProps(context) {
  const globals = await getGlobals(context);
  const params = new DrupalJsonApiParams();
  const path = getPathFromContext(context, "node--news");
  const nowTimeStamp = Date.now() / 1000;

  const node = await getResourceByPath(`${path}/${context.params.slug}`, {
    params: getParams("node--news"),
    locale: context.locale,
    defaultLocale: context.defaultLocale,
  });

  if (!context.preview && !node?.status) {
    return {
      notFound: true,
      revalidate: 30,
    };
  }

  const nodes = await getResourceCollection("node--news", {
    params: params
      .addFilter("status", 1)
      .addInclude(["field_image", "field_type"])
      .addFilter("id", node.id, "<>")
      .addFilter("langcode", context.locale)
      .addFilter("created", nowTimeStamp, "<=")
      .addPageLimit(3)
      .addSort("sticky", "DESC")
      .addSort("created", "DESC")
      .getQueryObject(),
    locale: context.locale,
    defaultLocale: context.defaultLocale,
  });

  return {
    props: {
      crumbs: getCrumbs(context, node, globals.menus.crumbsFallback),
      globals,
      node,
      nodes,
    },
    revalidate: 30,
  };
}


    export async function getStaticProps(ctx) {
        let res = _getStaticProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/node--news/[slug]',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  